import {
    PASSENGER_ID_TO_I18N_KEY,
    resolveSingularPassengerLabel,
} from "./passengerLabelResolver";

export const getSearchSelectedPassenger = (passengers: any, intl?: any) => {
        
    let totalWithoutInfants = 0;
    let totalWithInfants = 0;
    let selectedPassengerTypes = 0;
    let totalPassengerCount = 0;
    // Create formatted passenger count strings
    const passengerStrings: string[] = [];
    const passengerCounts: Record<string, number> = {};

    // Helper function to return a formatted label for each passenger type.
    // Format (per product spec):
    //   count === 1 → just the singular type label ("Adult", "Wheelchair")
    //   count >  1 → "<count>x <singular label>" ("6x Adult", "5x Wheelchair")
    // PTC source is dynamic via the shared resolver: API-provided labels
    // for en-UK/fr-FR, local i18n for ar-AE — never hardcoded.
    const getPassengerLabel = (key: string, count: number) => {
        if (intl) {
            const i18nKey = PASSENGER_ID_TO_I18N_KEY[key];
            if (i18nKey) {
                const label = resolveSingularPassengerLabel(key, i18nKey, intl);
                return count === 1 ? label : `${count}x ${label}`;
            }
        }

        // Fallback when no intl is provided — same "<count>x <label>"
        // format on count > 1, singular only on count === 1. Labels are
        // English hardcodes only as a last-resort dev-mode fallback;
        // production paths always go through the i18n branch above.
        switch (key) {
            case 'adults':
                return count === 1 ? 'adult' : `${count}x adult`;
            case 'children':
                return count === 1 ? 'child' : `${count}x child`;
            case 'seniorcitizens':
                return count === 1 ? 'senior citizen' : `${count}x senior citizen`;
            case 'students':
                return count === 1 ? 'student' : `${count}x student`;
            case 'reducedMobility':
                return count === 1 ? 'person with reduced mobility' : `${count}x person with reduced mobility`;
            case 'wheelchair':
                return count === 1 ? 'person with wheelchair' : `${count}x person with wheelchair`;
            case 'infants':
                return count === 1 ? 'infant' : `${count}x infant`;
            default:
                return count === 1 ? key : `${count}x ${key}`;
        }
    };

    // Loop through passenger types and counts
    for (const key in passengers) {
        const count = passengers[key];
        if (count > 0) {
            passengerCounts[key] = count;

            if (key === 'infants') {
                totalWithInfants += count;
                 selectedPassengerTypes += 1;
                //passengerStrings.push(getPassengerLabel(key, count));
            } else {
                totalWithoutInfants += count;
                totalWithInfants += count;
                selectedPassengerTypes += 1;
                const label = getPassengerLabel(key, count);
                passengerStrings.push(label);
            }
        }
        totalPassengerCount += count;
    }

    // Determine the passenger summary based on the conditions
    let passengerSummary;
    let allPassengerSummary;
    
    // Check if only infants are selected
    const onlyInfantsSelected = selectedPassengerTypes === 1 && passengers.infants > 0 && totalWithoutInfants === 0;
    
    if (selectedPassengerTypes === 1) {
        if (onlyInfantsSelected) {
            const infantLabel = getPassengerLabel('infants', passengers.infants);
            allPassengerSummary = infantLabel;
        } else {
            passengerSummary = passengerStrings[0];
            allPassengerSummary = passengerStrings[0];
        }
    } else {
        // If more than one type is selected, show the total count and "passengers"
        passengerSummary = `${totalWithoutInfants} passenger${totalWithoutInfants > 1 ? 's' : ''}`;
        
        // Apply translation if intl is provided
        if (intl) {
            const passengerKey = totalPassengerCount > 1 ? 'passengersText' : 'passengerText';
            allPassengerSummary = `${totalPassengerCount} ${intl.formatMessage({ id: passengerKey })}`;
        } else {
            allPassengerSummary = `${totalPassengerCount} passenger${totalPassengerCount > 1 ? 's' : ''}`;
        }
    }
    return {
        totalWithoutInfants,
        totalWithInfants,
        passengerSummary,
        passengerCounts,
        totalPassengerCount,
        allPassengerSummary
    };
}